import { ESearchBy, ESearchFilter } from "enum/ESearchBy";
import { enumToLabelValueList } from "./utils";
import { ECaseFilter } from "enum/ECaseFilter";
import { LabelValueType } from "types/types/Types";
import { EPermission } from "enum/EPermission";
import { ESortType } from "enum/ESortBy";

const TABLE_COLUMN_MIN_WIDTH = 100;
const TABLE_COLUMN_MAX_WIDTH = 300;
const FLEX = 1;

export const customFieldTypeList = [
    "Free text",
    "Drop down list",
    "Date picker",
    // "CPT",
    // "Diagnosis"
];

export const registryProcedureFields = [
    'patient_first_name',
    'patient_last_name',
    'gender',
    'date_of_birth',
    'institute',
    'mrn',
    'insurance',
    'type',
    'date',
    'diagnosisCodes',
    'cptCodes',
    'role',
    'vendors',
    'findings',
    'complications',
    'outcome',
    'notes',
    'images',
];

export const registryProcedureDetailsFields = [
    'type',
    'date',
    'role',
    'vendors',
    'findings',
    'complications',
    'outcome',
];

export const registryPatientInformationFields = [
    'patient_first_name',
    'patient_last_name',
    'gender',
    'date_of_birth',
    'institute',
    'mrn',
    'insurance',
];

export const tableColumnProps = {
    minWidth: TABLE_COLUMN_MIN_WIDTH,
    maxWidth: TABLE_COLUMN_MAX_WIDTH,
    flex: FLEX,
}

export const permissionsList: LabelValueType[] = [
    {
        label: 'Editor',
        value: 'EDITOR',
        key: 'EDITOR',
    },
    {
        label: 'Viewer',
        value: 'VIEWER',
        key: 'VIEWER',
    },
]

export const permissionValues: readonly EPermission[] = [
    EPermission.EDITOR,
    EPermission.VIEWER,
];

export const filterPatientsFilterList = enumToLabelValueList(ECaseFilter);

export const filterPatientsSearchByList = enumToLabelValueList(ESearchBy);

export const sortByOptionsList = enumToLabelValueList(ESortType);

export const exportNote = 'Exporting now. Once done, you will find the files in your Profile under Exported Procedures.';

export enum EBaseRegistriesPath {
    ALL_REGISTRIES = 'all-registries',
    MY_REGISTRIES = 'my-registries',
    SHARED_REGISTRIES = 'shared-registries',
}